import * as Actions from './ManuallySendActions';
import { CoughAnalysisSetType } from '../../misc/api/apiTypes';

export interface ManuallySendState {
    isVisible: boolean;
    isFetching: boolean;
    analysisSetId: string;
    selectedQAType: string;
    qaTypes: Array<CoughAnalysisSetType>;
}

export const initialManuallySend: ManuallySendState = {
    isVisible: false,
    isFetching: false,
    analysisSetId: null,
    selectedQAType: null,
    qaTypes: null,
}

export function manuallySendReducer(state: ManuallySendState = initialManuallySend, action: Actions.Action): ManuallySendState {
    switch (action.type) {
        case Actions.ActionType.SelectQAType:
            return {
                ...state,
                selectedQAType: action.qaTypeId,
            }
        case Actions.ActionType.RequestQATypes:
            return {
                ...state,
                isFetching: true,
            }
        case Actions.ActionType.ReceiveQATypes:
            return {
                ...state,
                isFetching: false,
                qaTypes: action.qaTypes,
                selectedQAType: action.qaTypes[0].Id,
            };
        case Actions.ActionType.DisableActionButton:
            return {
                ...state,
                isFetching: true,
            }
        default:
            return state;
    }
}
